import { JSONLDMetadata } from '../types/crowdhandler';

const getJSONLDMetadata = (elementId: string): JSONLDMetadata | null => {
    const ui_element = document.querySelector(elementId);
    if (ui_element && ui_element.textContent) {
        try {
            return JSON.parse(ui_element.textContent) as JSONLDMetadata;
        } catch (e) {
            return null;
        }
    }
    return null;
};

export { getJSONLDMetadata };